/* */ 
"use strict";
var core_1 = require('@angular/core');
var lang_1 = require('../facade/lang');
var collection_1 = require('../facade/collection');
var NgClass = (function() {
  function NgClass(_iterableDiffers, _keyValueDiffers, _ngEl, _renderer) {
    this._iterableDiffers = _iterableDiffers;
    this._keyValueDiffers = _keyValueDiffers;
    this._ngEl = _ngEl;
    this._renderer = _renderer;
    this._initialClasses = [];
  }
  Object.defineProperty(NgClass.prototype, "initialClasses", {
    set: function(v) {
      this._applyInitialClasses(true);
      this._initialClasses = lang_1.isPresent(v) && lang_1.isString(v) ? v.split(' ') : [];
      this._applyInitialClasses(false);
      this._applyClasses(this._rawClass, false);
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(NgClass.prototype, "rawClass", {
    set: function(v) {
      this._cleanupClasses(this._rawClass);
      if (lang_1.isString(v)) {
        v = v.split(' ');
      }
      this._rawClass = v;
      this._iterableDiffer = null;
      this._keyValueDiffer = null;
      if (lang_1.isPresent(v)) {
        if (collection_1.isListLikeIterable(v)) {
          this._iterableDiffer = this._iterableDiffers.find(v).create(null);
        } else {
          this._keyValueDiffer = this._keyValueDiffers.find(v).create(null);
        }
      }
    },
    enumerable: true,
    configurable: true
  });
  NgClass.prototype.ngDoCheck = function() {
    if (lang_1.isPresent(this._iterableDiffer)) {
      var changes = this._iterableDiffer.diff(this._rawClass);
      if (lang_1.isPresent(changes)) {
        this._applyIterableChanges(changes);
      }
    }
    if (lang_1.isPresent(this._keyValueDiffer)) {
      var changes = this._keyValueDiffer.diff(this._rawClass);
      if (lang_1.isPresent(changes)) {
        this._applyKeyValueChanges(changes);
      }
    }
  };
  NgClass.prototype.ngOnDestroy = function() {
    this._cleanupClasses(this._rawClass);
  };
  NgClass.prototype._cleanupClasses = function(rawClassVal) {
    this._applyClasses(rawClassVal, true);
    this._applyInitialClasses(false);
  };
  NgClass.prototype._applyKeyValueChanges = function(changes) {
    var _this = this;
    changes.forEachAddedItem(function(record) {
      _this._toggleClass(record.key, record.currentValue);
    });
    changes.forEachChangedItem(function(record) {
      _this._toggleClass(record.key, record.currentValue);
    });
    changes.forEachRemovedItem(function(record) {
      if (record.previousValue) {
        _this._toggleClass(record.key, false);
      }
    });
  };
  NgClass.prototype._applyIterableChanges = function(changes) {
    var _this = this;
    changes.forEachAddedItem(function(record) {
      _this._toggleClass(record.item, true);
    });
    changes.forEachRemovedItem(function(record) {
      _this._toggleClass(record.item, false);
    });
  };
  NgClass.prototype._applyInitialClasses = function(isCleanup) {
    var _this = this;
    this._initialClasses.forEach(function(className) {
      return _this._toggleClass(className, !isCleanup);
    });
  };
  NgClass.prototype._applyClasses = function(rawClassVal, isCleanup) {
    var _this = this;
    if (lang_1.isPresent(rawClassVal)) {
      if (lang_1.isArray(rawClassVal)) {
        rawClassVal.forEach(function(className) {
          return _this._toggleClass(className, !isCleanup);
        });
      } else if (rawClassVal instanceof Set) {
        rawClassVal.forEach(function(className) {
          return _this._toggleClass(className, !isCleanup);
        });
      } else {
        collection_1.StringMapWrapper.forEach(rawClassVal, function(expVal, className) {
          if (lang_1.isPresent(expVal))
            _this._toggleClass(className, !isCleanup);
        });
      }
    }
  };
  NgClass.prototype._toggleClass = function(className, enabled) {
    className = className.trim();
    if (className.length > 0) {
      if (className.indexOf(' ') > -1) {
        var classes = className.split(/\s+/g);
        for (var i = 0,
            len = classes.length; i < len; i++) {
          this._renderer.setElementClass(this._ngEl.nativeElement, classes[i], enabled);
        }
      } else {
        this._renderer.setElementClass(this._ngEl.nativeElement, className, enabled);
      }
    }
  };
  NgClass.decorators = [{
    type: core_1.Directive,
    args: [{
      selector: '[ngClass]',
      inputs: ['rawClass: ngClass', 'initialClasses: class']
    }]
  }];
  NgClass.ctorParameters = [{type: core_1.IterableDiffers}, {type: core_1.KeyValueDiffers}, {type: core_1.ElementRef}, {type: core_1.Renderer}];
  return NgClass;
}());
exports.NgClass = NgClass;
